import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import product1 from "../../static/media/Home/Products/product1.webp";
import product2 from "../../static/media/Home/Products/product2.webp";
import product3 from "../../static/media/Home/Products/product3.webp";
import product4 from "../../static/media/Home/Products/product4.webp";
import product5 from "../../static/media/Home/Products/product5.webp";
import product6 from "../../static/media/Home/Products/product6.webp";
import main from "../../static/media/Home/Products/main.webp";

const PRIMARY = "#06BBC7";

const products = [
  {
    title: "LIMPIADORAS FACIALES",
    image: product1,
  },
  {
    title: "TÓNICOS",
    image: product2,
  },
  {
    title: "FACTOR DE PROTECCIÓN SOLAR",
    image: product3,
  },
  {
    title: "SERUM",
    image: product4,
  },
  {
    title: "SHAMPOO & MASCARILLA CAPILAR",
    image: product5,
  },
  {
    title: "ACEITES ESENCIALES",
    image: product6,
  },
];

const WaveTop = () => (
  <Box
    component="svg"
    viewBox="0 0 1440 120"
    preserveAspectRatio="none"
    sx={{
      position: "absolute",
      top: -1,
      left: 0,
      width: "100%",
      height: { xs: 58, md: 92 },
      zIndex: 1,
      display: "block",
    }}
  >
    <path
      d="M0,0H1440V54C1280,98,1120,108,960,76C800,44,640,-2,480,22C320,46,160,118,0,74V0Z"
      fill="#ffffff"
    />
  </Box>
);

const WaveBottom = () => (
  <Box
    component="svg"
    viewBox="0 0 1440 120"
    preserveAspectRatio="none"
    sx={{
      position: "absolute",
      bottom: -1,
      left: 0,
      width: "100%",
      height: { xs: 58, md: 92 },
      zIndex: 1,
      display: "block",
      transform: "rotate(180deg)",
    }}
  >
    <path
      d="M0,0H1440V54C1280,98,1120,108,960,76C800,44,640,-2,480,22C320,46,160,118,0,74V0Z"
      fill="#ffffff"
    />
  </Box>
);

const ProductItem = ({ title, image, index }) => (
  <Box
    component={motion.div}
    initial={{ opacity: 0, y: 24, scale: 0.96 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    whileHover={{ y: -7 }}
    transition={{ duration: 0.38, ease: "easeOut", delay: index * 0.04 }}
    viewport={{ once: true, amount: 0.35 }}
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: { xs: 1.1, md: 1.3 },
      minWidth: 0,
    }}
  >
    <Box
      sx={{
        width: { xs: 88, sm: 104, md: 120, lg: 132 },
        height: { xs: 88, sm: 104, md: 120, lg: 132 },
        borderRadius: "50%",
        bgcolor: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 18px 34px rgba(0,0,0,0.12)",
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={image}
        alt={title}
        loading="lazy"
        sx={{
          width: "74%",
          height: "74%",
          objectFit: "contain",
          display: "block",
        }}
      />
    </Box>

    <Typography
      sx={{
        color: "#ffffff",
        fontSize: { xs: "0.68rem", sm: "0.76rem", md: "0.82rem" },
        fontWeight: 800,
        lineHeight: 1.28,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        maxWidth: { xs: 112, sm: 130, md: 150 },
      }}
    >
      {title}
    </Typography>
  </Box>
);

const Products = () => {
  const topProducts = products.slice(0, 3);
  const bottomProducts = products.slice(3);

  return (
    <Box
      component="section"
      sx={{
        bgcolor: PRIMARY,
        py: { xs: 9, md: 12 },
        overflow: "hidden",
        position: "relative",
      }}
    >
      <WaveTop />
      <WaveBottom />

      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            maxWidth: 760,
            mx: "auto",
            mb: { xs: 4.5, md: 6 },
            px: { xs: 1, sm: 0 },
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontFamily: "'Playfair Display', serif",
              color: "#ffffff",
              fontSize: { xs: "2.25rem", sm: "3rem", md: "3.7rem" },
              fontWeight: 600,
              lineHeight: 1.02,
              letterSpacing: "-0.045em",
              mb: 2,
            }}
          >
            Productos que utilizamos
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.92)",
              fontSize: { xs: "1rem", sm: "1.08rem", md: "1.16rem" },
              fontWeight: 400,
              lineHeight: 1.75,
              maxWidth: 700,
              mx: "auto",
            }}
          >
            Visita nuestra tienda virtual y descubre productos profesionales de
            marcas seleccionadas para complementar tu rutina de cuidado facial,
            corporal y capilar.
          </Typography>
        </Box>

        <Box
          sx={{
            maxWidth: 1180,
            mx: "auto",
            display: { xs: "flex", md: "grid" },
            flexDirection: { xs: "column", md: "initial" },
            gridTemplateColumns: { md: "1fr 1.05fr" },
            alignItems: "center",
            gap: { xs: 3.2, md: 6, lg: 8 },
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: { xs: "contents", md: "flex" },
              flexDirection: "column",
              alignItems: "center",
              gap: { md: 4 },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                gap: { xs: 2.1, sm: 2.8, md: 4 },
                alignItems: "start",
                order: { xs: 1, md: "initial" },
              }}
            >
              {topProducts.map((item, index) => (
                <ProductItem
                  key={item.title}
                  title={item.title}
                  image={item.image}
                  index={index}
                />
              ))}
            </Box>

            <Box
              sx={{
                width: { xs: "100%", md: "auto" },
                display: "flex",
                justifyContent: "center",
                order: { xs: 4, md: "initial" },
                mt: { xs: 1, md: 0 },
              }}
            >
              <Button
                component="a"
                href="/tienda"
                sx={{
                  bgcolor: "#ffffff",
                  color: PRIMARY,
                  px: { xs: 3.6, md: 4.4 },
                  py: { xs: 1.1, md: 1.2 },
                  borderRadius: "999px",
                  textTransform: "none",
                  fontWeight: 800,
                  fontSize: { xs: "0.92rem", md: "0.98rem" },
                  boxShadow: "0 18px 34px rgba(0,0,0,0.16)",
                  "&:hover": {
                    bgcolor: "#f7feff",
                    boxShadow: "0 22px 42px rgba(0,0,0,0.2)",
                  },
                }}
              >
                Conocer productos
              </Button>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                gap: { xs: 2.1, sm: 2.8, md: 4 },
                alignItems: "start",
                order: { xs: 3, md: "initial" },
              }}
            >
              {bottomProducts.map((item, index) => (
                <ProductItem
                  key={item.title}
                  title={item.title}
                  image={item.image}
                  index={index + 3}
                />
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
              maxWidth: { xs: 430, sm: 520, md: 560 },
              mx: "auto",
              order: { xs: 2, md: "initial" },
            }}
          >
            <Box
              component="img"
              src={main}
              alt="Productos profesionales Lily's Sunflowers"
              loading="lazy"
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
                borderRadius: { xs: "24px", md: "34px" },
                boxShadow: "0 18px 38px rgba(0,0,0,0.18)",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Products;